import { Callout } from "@blueprintjs/core";
import type { ScheduledEventRecurringSettings } from "@package/ui-gql/index-data-access";
import { DashboardCard } from "../../../../DashboardCard/DashboardCard";
import { summarizeRecurrence } from "../scheduler-recurrence-utils";
import { SchedulerOccurrencePreview } from "./SchedulerOccurrencePreview";

type SchedulerRecurrenceSummaryProps = {
  recurring: ScheduledEventRecurringSettings;
  start?: Date | string | null;
};

/**
 * The recurrence rule is create-only -- there's no `recurring` field on the
 * update mutation, so any edit here would silently do nothing. This is the
 * honest read-only view for an existing event: show what the rule actually
 * is, and point at "delete + recreate" as the only way to change it.
 */
export function SchedulerRecurrenceSummary({
  recurring,
  start,
}: SchedulerRecurrenceSummaryProps) {
  const fallbackStart = start ? new Date(start) : new Date();
  const summary = summarizeRecurrence(recurring, fallbackStart);

  return (
    <DashboardCard title="Repeat">
      <Callout icon="lock" intent="none">
        Repeat rule can&apos;t be changed after creation. Delete this series and
        create a new one to change it.
      </Callout>
      {summary && <p className="mt-3 text-sm text-brand-ink">{summary}</p>}
      <div className="mt-2">
        <SchedulerOccurrencePreview
          recurring={recurring}
          start={fallbackStart}
        />
      </div>
    </DashboardCard>
  );
}
